export default __webpack_public_path__ + "assets/images/d9da65e4867715811997d36b08f1b036.svg";